<template>
  <div>
    <div v-for="(value, key) in homeByProjects" :key="key" class="project">
      <div class="project-name">โครงการ {{ key }}</div>
      <div v-for="home in value" :key="home.id" class="home">
        <div>บ้านเลขที่: {{ home.addressNumber }}</div>
        <div>Home ID: {{ home.id }}</div>
        <div>{{ home.userRole }}</div>
        <div>
          <sc-button variant="danger" size="sm" @click="handleClickRemove(home)"
            >ไล่ออก</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userRoleMapper } from "@/lib/mapper"
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ScButton,
  },
  props: {
    homes: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    homeByProjects() {
      return this.homes.reduce((all, home) => {
        const nHome = { ...home, userRole: userRoleMapper[home.userRole] }
        const existing = all[home.projectName] || []

        return {
          ...all,
          [home.projectName]: [...existing, nHome],
        }
      }, {})
    },
  },
  methods: {
    handleClickRemove(home) {
      this.$emit("remove", home)
    },
  },
}
</script>

<style lang="scss" scoped>
.project {
  margin-bottom: 30px;
}

.project-name {
  font-weight: bold;
}

.home {
  display: grid;
  grid-template-columns: 170px 150px 1fr 100px;
  grid-gap: 15px;

  padding: 8px 0;

  align-items: center;
}
</style>
